import PropTypes from 'prop-types'
import styled from 'styled-components'
import { PureComponent } from 'react'
import { isEmpty } from 'lodash'
import Navigation from './navigation'
import Grid from 'shared/components/search/grid'
import gifProps from 'shared/prop-types/gif'
import channelProps from 'shared/prop-types/channel'
import FeedChannel from '../feed/feed-channel'
import AddGif from 'shared/components/gif-grid/add-gif'
import AfterGif from 'shared/components/list-item-footer/list-item-footer'
import Tags from 'shared/components/gif-grid/gif-tags'
import feedcss from '../feed/feed-channel.css'
import { processChannelGifs } from 'shared/util/gif-process'
import { getChannelsSearchPath } from 'shared/util/search'
import { endsWithWords } from 'shared/util/string'
import css from './grid.css'
import { Loader } from 'shared/components/preloader-animation'
const { arrayOf, bool, object, func, number, shape, string } = PropTypes
const IMAGE_TYPES = ['gif', 'gifs', 'sticker', 'stickers']

const Container = styled.div`
    margin-top: 30px;
`
const DesktopAfterGif = props => (
    <div>
        <Tags {...props} />
        <div style={{ position: 'absolute', width: '100%' }}>
            <AfterGif isMobile={false} items={['facebook', 'twitter', 'pinterest', 'link', 'embed']} {...props} />
        </div>
    </div>
)

export default class ChannelGrid extends PureComponent {
    static propTypes = {
        channelId: number.isRequired,
        channel: channelProps,
        searchQuery: string,
        showNavigation: bool,
        gridProps: shape({
            autoPlay: bool,
            gifs: arrayOf(gifProps),
            isFetching: bool,
            fetchGifs: func.isRequired,
            permissions: object,
            toggleEditMode: func,
            updateEditMode: func,
            editMode: object,
        }),
        gridType: string.isRequired,
        receivedGifs: func.isRequired,
    }

    state = {
        // prevents the no gifs loader from displaying while we fetch
        isLoading: true,
    }

    async componentDidMount() {
        const {
            channelType,
            fetchGifs,
            channel: { id },
            query,
        } = this.props
        let url

        // Channels API & Search return different response formats
        if (channelType === 'tagged_channel' || channelType === 'search_channel') {
            url = getChannelsSearchPath(query, id, channelType === 'tagged_channel')
        } else {
            url = `/api/v3/channels/${id}/gifs/`
        }

        await fetchGifs(url, processChannelGifs)
        this.hasFetchedGifs = true
        this.setState({
            isLoading: false,
        })
    }

    render() {
        const {
            channel,
            gridProps,
            searchQuery,
            showNavigation,
            search,
            isTagView,
            gridType,
            nextUrl,
            fetchGifs,
            isOwner,
        } = this.props
        const { isLoading } = this.state
        const {
            display_name: displayName,
            root_channel: rootChannel,
            has_children: hasChildren,
            content_type: contentType,
        } = channel
        const { gifs } = gridProps
        const imageType = contentType === 'sticker' ? 'Stickers' : 'GIFs'
        const isVerified =
            channel.user &&
            (channel.user.is_verified || channel.user.user_type === 'partner' || channel.user.user_type === 'artist')
        let title = `All the ${displayName} ${endsWithWords(displayName, IMAGE_TYPES) ? '' : imageType}`
        if (searchQuery || isTagView || !hasChildren) title = null

        if (isLoading) {
            return <Loader isFetching={isLoading} />
        }

        return (
            <Container>
                <div data-copy="container">
                    {!isEmpty(gifs) && showNavigation ? (
                        <Navigation
                            channel={isEmpty(rootChannel) ? channel : rootChannel}
                            title={title}
                            search={search}
                            isOwner={isOwner}
                            gridType={gridType}
                        />
                    ) : null}
                    {gridType === 'feed' ? (
                        <FeedChannel
                            {...this.props}
                            gridTemplate={'feed_channel'}
                            isOffScreen={false}
                            style={{ marginTop: 20 }}
                            css={feedcss}
                            afterGif={DesktopAfterGif}
                            fetchGifs={() => fetchGifs(nextUrl, processChannelGifs)}
                            shouldUseLinkFallback={true}
                        />
                    ) : !isEmpty(gifs) || isOwner ? (
                        <Grid
                            groupId={`CHANNEL - ${channel.id}`}
                            category="channel"
                            processor={processChannelGifs}
                            columns={3}
                            showTV={isVerified && !searchQuery && !isTagView}
                            isOwner={isOwner}
                        >
                            {isOwner && <AddGif />}
                        </Grid>
                    ) : (
                        <div className={css.noResults} />
                    )}
                </div>
            </Container>
        )
    }
}
